  <template>
  <div class="soup-container">

    <div v-if="storeState.activeQueue>=0">
      <div class="search-text-container">
        <div class="queues-container">
          <v-tabs hide-slider :height="38" :vertical="false" v-model="storeState.activeQueue" slider-color="yellow">
            <v-tab v-for="(tab, index) in storeState.settings.team.queues" :key="tab.id" ripple>
              {{ tab.name }} {{ tab.id }}
            </v-tab>
          </v-tabs>
        <div>
          
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <span v-on="on" class="save-search-q">
                <v-btn icon @click="saveSearchAsQ">
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </span>
            </template>
            <span>Create queue</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <span v-on="on" class="save-search-q">
                <v-btn icon @click="goToSearch">
                  <v-icon>
                    mdi-magnify
                  </v-icon>
                </v-btn>
              </span>
            </template>
            <span>Go to search</span>
          </v-tooltip>
        </div>
      </div>
    </div>
    </div>
    <div v-else class="soup-search-container">
      <div class="search-underlay">
        <div v-html="underlay"></div>
      </div>
      <div class="search-text-container">
        <textarea 
          placeholder="Search (use # for tags or ! for reminders)" ref="searchText" 
          v-model="storeState.searchTerm" v-on:keyup="search" rows="1" wrap="off" 
          class="search-text mousetrap" spellcheck="false">
        </textarea>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <span v-on="on" class="go-to-queues">
              <v-btn icon @click="goToQueues">
                <v-icon>
                  mdi-format-list-bulleted
                </v-icon>
              </v-btn>
            </span>
          </template>
          <span>Go to queues</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <span v-on="on" class="save-search">
              <v-btn icon @click="saveSearchAsQ()">
                <v-icon>
                  mdi-plus
                </v-icon>
              </v-btn>
            </span>
          </template>
          <span>Create queue</span>
        </v-tooltip>
      </div>
    </div>
    <div class="searchContainer">
      <div>
        <div v-if="storeState.dataModel.users && storeState.dataModel.users.rows && storeState.dataModel.users.rows.length === 0">
          Loading.. 
        </div>
        <div ref="searchResultsContainer">
          <div 
          class="searchResultRows"
          :ref="'searchItem_' + index"
          :id="'searchItem_' + index"
          v-for="(row, index) in storeState.soupResults"
          :key="row.email"
          @mouseover="hoverRow(row)"
          @mouseleave="hoverRow(row)"
          @click="rowClick"
          :class="{'active': (index === storeState.searchIndex), 'row-hover': storeState.searchIndex < 0 }"
          >
            <div>
              <v-row>
                <v-col cols="12" sm="5" md="5">
                  <!-- {{ row.team_name }}  -->
                  <strong>{{ row.email }}</strong> {{row.state}}
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <span :class="{'row-reminder': true, 'red': store.pastDue(row).red}">{{getFromNow(row)}}</span>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <tags v-if="getTags(row)" :tags="getTags(row)" :row="row"></tags>
                </v-col>
                <v-col cols="12" sm="1" md="1" class="text-right">
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>  
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import { store } from '../store.js';
import Tags from './Tags'
import draggable from 'vuedraggable'
Vue.component('tags', Tags);


export default {
  mounted() {
    this.focusSearch()
  },
  data() {
    return {
      storeState: store.state,
      store: store,
      underlay: '',
      tempSearch: '',
      newTag: '',
      tags: [],
    };
  },
  components: {
    draggable,
  },
  watch: {
    'storeState.dataModel.users.rows': {
        handler: function (val, oldVal) {
            console.log('storeState.dataModel.users.rows updated: ')
            this.cleanAndhighlightSearch()
            // if (this.storeState.activeQueue) {
              
            // } else {
            //   // this.storeState.soupResults = this.storeState.dataModel.users.rows.slice(0, 20)
            //   this.storeState.soupResults = JSON.parse(JSON.stringify(this.storeState.dataModel.users.rows.slice(0, 20)));
            // }
        },
        deep: true,
    },
    'storeState.activeQueue': {
        handler: function (val, oldVal) {
          console.log('activeQueue 1', 'queue: ', val, '   oldVal:', oldVal)
          // this.$route.params.id = val
          if (val >=0 && val != oldVal) {
            this.$router.push({ name: 'Soup', params: { queue: val }}).catch(err => console.error(err))
            let q = this.storeState.settings.team.queues.find(q => q.id === Number(val))
            this.loadQueue(q.id)
          } else if (!val)  {
            // this.storeState.soupResults = this.storeState.dataModel.users.rows.slice(0, 20)
            this.cleanAndhighlightSearch()
          }
          // this.storeState.searchTerm = q
          // this.search({})
        }
    },
    '$route.params.queue': function (val, oldVal) {
      console.log('queue changed', val, oldVal)
      if (val >=0 && val != oldVal) {
        this.loadQueue(val)
      } else {
        this.storeState.activeQueue = -1
      }
    },
  },
  filters: {
    fromNowFilter: function (data) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${data.email}`]
      if (details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    }
  },
  methods: {
    moment: function () {
      return moment();
    },
    focusSearch() {
      if (this.$refs.searchText) this.$refs.searchText.focus()
    },
    hoverRow() {
      this.storeState.searchIndex = -1
    },
    rowClick(e) {
      console.log('rowClick: ', e)
      var self = this
      if (e.target.nodeName === 'INPUT') return
      if (e.currentTarget.id) {
        console.log('e.currentTarget.id: ', e.currentTarget.id)
        this.$parent.openSoupDetails('', Number(e.currentTarget.id.replace('searchItem_', '')))
      }
    },
    getFromNow: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    },
    getTags: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.tags) {
        return details.tags
      } else {
        return ''
      }
    },
    saveSearchAsQ(val) {
      // console.log('saveSearchAsQ: ', val, this.storeState.searchTerm)
      // this.storeState.currentFocus = 'cmdk'
      // this.storeState.searchIndex = 0
      // this.storeState.cmdkActive = true;

      // this.storeState.cmdkParentCmd = e.cmdkParentCmd || false
      // this.storeState.cmdkInput = e.cmdkInput || ''
      // this.storeState.cmdkParentCmd = 'createTag'
      // this.$parent.openCmdK({cmdkParentCmd: 'createTag'})
      // this.storeState.cmdkInput = 'b'
      // this.$mousetrap.trigger('command+k');
      this.$emit('open-cmdk',
        {cmdkParentCmd: 'createQueue', cmdkInput: ''}
      )
    },
    goToQueues() {
      this.$router.push({ name: 'Soup', params: { queue: 0 }}).catch(err => console.error(err))
    },
    goToSearch() {
      this.$router.push({ name: 'Soup', params: { queue: -1 }}).catch(err => console.error(err))
    },
    validateSearch(val) {
      console.log('val term: ', val)
      this.storeState.searchTerm = this.newTag
      if (val.startsWith('#')) return true
      return false
    },
    search(e) {
      var self = this
      if (![13, 40, 38].includes(e.keyCode)) this.storeState.searchIndex = 0
      console.log('search term: ', this.storeState.searchTerm, e)
      if ([13].includes(e.keyCode)) {
        // let suggestion = self.storeState.soupResults[self.storeState.searchIndex]
        this.$parent.openSoupDetails('', self.storeState.searchIndex)
        e.preventDefault()
        console.log('hit enter, up, down...')
        return
      }
      this.cleanAndhighlightSearch()
    },
    cleanAndhighlightSearch(opts) {
      if (opts && opts.searchTerm) {
        var searchTerm = searchTerm.toLowerCase()
      } else {
        var searchTerm = this.storeState.searchTerm.toLowerCase()
      }
      if (searchTerm.length === 0) return
      var terms = searchTerm.split(/(\s+)/)
      let tags = []
      let reminders = []
      let texts = []
      let filters = []
      let html = ''
      let where = ''
      var tagSql = ''
      var reminderSql = ''
      let detail_type = 'users'
      for (let i = 0; i < terms.length; i++) {
        let term = terms[i];
        if (term.startsWith('#')) {
          let fullTag = this.storeState.allTags.filter(o => o.text === term.replace('#', ''))
          if (fullTag.length > 0) {
            tags.push(term)
            tagSql+= `'${term.replace('#', '')}',`
            html+= `<span class="term-underlay">${term}</span>`
          } else {
            var suggestedTag = this.storeState.allTags.filter(o => o.text.startsWith(term.replace('#', '')))
            if (suggestedTag.length === 0) {
              console.log('no suggestions...')
            } else {
              suggestedTag = `#${suggestedTag[0].text}`
            }
            this.$refs.searchText
            this.storeState.suggestedTagDetails = {tag: suggestedTag, userEntered: term, start: this.$refs.searchText.selectionStart}
            html+= `<span class="term-underlay term-underlay-partial">${suggestedTag}</span>`
          }
        } else if (term.startsWith('!')) {
          // reminders.push(term)
          let fullReminder = this.storeState.reminderOptions.filter(o => o.text === term.replace('!', ''))
          if (fullReminder.length > 0) {
            let r = fullReminder[0].calc().toISOString()
            reminders.push(r)
          } else {
            var suggestedReminder = this.storeState.reminderOptions.filter(o => o.text.startsWith(term.replace('!', '')))
            if (suggestedReminder.length === 0) {
              console.log('no suggestions...')
            } else {
              suggestedReminder = `!${suggestedReminder[0].text}`
            }
            this.$refs.searchText
            this.storeState.suggestedReminderDetails = {reminder: suggestedReminder, userEntered: term, start: this.$refs.searchText.selectionStart}
            html+= `<span class="term-underlay term-underlay-partial">${suggestedReminder}</span>`
          }
        } else if (term === ' ') {
          html+= `<span class="term-underlay-text">${term}</span>`
        } else {
          texts.push(term)
          html+= `<span class="term-underlay-text">${term}</span>`
        }
      }
      var tagged = []
      if (tags.length > 0) {
        for (let [key, value] of Object.entries(this.storeState.editableDetailsAll)) {
          if (value.tags.length > 0) {
            let rowTags = value.tags.map(t => t.text)
            let hasTag = tags.some(t => rowTags.includes(t.replace('#', '')))
            if (hasTag) tagged.push(key.replace(`${detail_type}-`, ''))
          }
        }
      }
      var reminded = []
      if (reminders.length > 0) { //reminders in search, only process first
        for (let [key, value] of Object.entries(this.storeState.editableDetailsAll)) {
          if (value.reminder) { //reminder for this row
            let searchReminder = reminders[0]
            if (value.reminder <= searchReminder) reminded.push(key.replace(`${detail_type}-`, ''))
          }
        }
      }
      let taggedOrReminded = _.union(reminded, tagged)
      let cleanTerm = texts.join('').trim()
      if (this.storeState.dataModel && this.storeState.dataModel.users && this.storeState.dataModel.users.rows) {
        this.storeState.soupResults = JSON.parse(JSON.stringify(this.storeState.dataModel.users.rows));
      } else {
        return false
      }
      
      if (taggedOrReminded.length > 0) {
        this.storeState.soupResults = this.storeState.soupResults.filter(o => taggedOrReminded.includes(o.email))
      }
      if (cleanTerm.length > 0) {
        this.storeState.soupResults = this.storeState.soupResults.filter(o => o.email.includes(cleanTerm)).slice(0, 20)
      }
      console.log('tagged...', tagged)
      console.log('reminded...', reminded)
      this.underlay = html
      return true
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
    loadQueue(queue) {
      console.log('queue: ', queue)
      if (queue>=0) {
        queue = Number(queue)
        let q = this.storeState.settings.team.queues.find(q => q.id === queue)
        if (q) {
          this.storeState.searchTerm = q.query
          this.storeState.activeQueue = q.id
          this.cleanAndhighlightSearch()
        }
        
      }
    },
  },
  created() {
    // this.loadQueue(this.$route.params.queue)
    this.storeState.activeQueue = this.$route.params.queue
  },
};
</script>

<style>
.active {
  background-color: #eee;
  border-left-color: #333;
  border-left-style: solid;
  border-left-width: 3px;
}
.searchResultRows {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;
}
.row-hover:hover {
  background-color: #eee;
  border-left-color: #333;
  border-left-style: solid;
  border-left-width: 3px;
}
.vue-input-tag-wrapper {
    background-color: #fff;
    border: none;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}

.vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: none;
    color: #333;
    flex-grow: 1;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 0px;
}

.vue-input-tag-wrapper .input-tag {
    background-color: #eee;
    border: 1px solid #eee;
    border-radius: 2px;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.search-input-container {
  padding-bottom: 20px;
  padding-left: 40px;
}
.row-sub-title {
  color: #ccc;
  padding-left: 10px;
}
.row-reminder {
  color: rgb(46, 170, 220);
  padding-left: 10px;
}
.save-search {
  float: right;
  margin-top: -50px;
  margin-right: 65px;
}
.go-to-queues {
  float: right;
  margin-top: -50px;
  margin-right: 65px;
  padding-right: 65px;
}

.searchContainer {
  padding-top: 50px;
}
.term-underlay {
  /* margin-left: 8px; */
  /* margin-top: 1px; */
  background: rgba(84, 172, 220, 0.2);
  box-shadow: 0 0 0 2px rgba(84, 172, 220, 0.2);
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-text {
  /* margin-left: 0px; */
  background: transparent;
  box-shadow: none;
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-partial {
  /* margin-left: 0px; */
  background: rgba(249, 150, 255, 0.2);
  box-shadow: none;
}
.search-underlay {
  position: absolute;
  width: 100%;
}
.search-text-container {
  position: absolute;
  width: 100%;
  height: 38px;
  font-size: 20px;
  outline: none;
}
#soupSearchContainer {
  display: -webkit-inline-box;
  position: absolute;
  width: 100%;
  margin-left: 20px;
}
.soup-search-container {
  margin-left: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.soup-container {
  margin-top: 15px;
}
</style>